let currentJoyfulApp: unknown = null

export function setCurrentJoyfulApp(app: unknown) {
  currentJoyfulApp = app
}

export function getCurrentJoyfulApp<TApp>() {
  if (currentJoyfulApp === null) {
    throw new Error('Joyful app runtime is not initialized')
  }

  return currentJoyfulApp as TApp
}
